import React, { useContext } from 'react';
import { Box, Heading } from '@chakra-ui/core';

import { ComponentContext } from '../../context/componentContext';

import VideoPlayer from '../../components/VideoPlayer';

const Tutorial = () => {
  document.title = 'CrowdFarmer | Help Guide Videos';

  const { menuOpen, setLoading } = useContext(ComponentContext);

  setLoading(false);

  const videos = [
    { _id: 'lMGEvOfsITg', title: 'Complete Farmer Intro' },
    { _id: 'oXolRw4dK0I', title: 'How to set up your signature on your Crowdfarmer dashboard.' },
    { _id: 'oQwlBXImKxU', title: 'How To Access Your Crowdfarmer Contract' }
  ];

  return (
    <Box className="relative container mx-auto pt-32 pb-20">
      <Box className="flex flex-wrap justify-center pb-10">
        {videos.map((video, index) => (
          <Box className="w-full md:w-1/2 py-8 css-0" key={index}>
            <VideoPlayer id={video._id} />
            <Heading
              as="h4"
              p={{ base: '10px' }}
              mr={{ base: '20px' }}
              minH={{ base: '80px', lg: '100px' }}
              className="rounded-b bg-cf-400"
            >
              {video.title}
            </Heading>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Tutorial;
